import { type AxiosError } from 'axios';
import { toastr } from 'react-redux-toastr';
import store from '../store/store';

export function axiosErrorHandling(error: AxiosError) {
  if (String(error.response?.status) === '400') {
    const title = `${error.response?.data?.error}`;

    if (error.response?.data?.data?.errors) {
      const errors = Object.keys(error.response?.data?.data?.errors);
      for (let i = 0; i < errors.length; i++) {
        const suberror = errors[i];
        const message = `${error.response?.data?.data?.errors[suberror]}`;
        toastr.error(title, message);
        return;
      }
    } else {
      toastr.error(title, `${error.response?.data?.message}`);
      return;
    }
  }

  if (String(error.response?.status) === '404') {
    toastr.warning('404 Not Found', `Error URL: ${error.request?.responseURL}`);
    return;
  }

  if (String(error.response?.status) === '500') {
    toastr.error('500 server error', `${error.response?.data?.message}`);
    return;
  }

  if (String(error.response?.status) === '405') {
    const title = `${error.response?.data?.error}`;
    toastr.error(title, `${error.response?.data?.message}`);
    return;
  }

  if (String(error.response?.status) === '405') {
    const title = `${error.response?.data?.error}`;
    toastr.error(title, `${error.response?.data?.message}`);
    return;
  }

  if (String(error.response?.status) === '401') {
    const title = `${error.response?.data?.error}`;
    toastr.error(title, `${error.response?.data?.message}`);
    store.dispatch({ type: 'LOGOUT' });
  }

  const title = `${error.response?.data?.error}`;
  toastr.error(title, `${error.response?.data?.message}. URL:${error.request?.responseURL}`);
}
